import { AuthContext } from './AuthContext'
import React, { useState, useEffect, useContext } from 'react'
import { Dropdown, Container, Row, Col } from 'react-bootstrap'
import axios from 'axios'
import ReactEcharts from 'echarts-for-react'

const Satisfy = () => {
  const { setIsLoading } = useContext(AuthContext)

  const [data, setData] = useState(null)
  // 潛在客戶總數
  const [totalCount, setTotalCount] = useState(0)
  const [q2options, setQ2options] = useState([])
  const [q3options, setQ3options] = useState([])
  const [q4options, setQ4options] = useState([])
  const [q5options, setQ5options] = useState([])
  const [q6options, setQ6options] = useState([])
  const [q7options, setQ7options] = useState([])

  const [originalQ4options, setOriginalQ4options] = useState([])

  const [q5Average, setQ5Average] = useState(0)
  const [q6Average, setQ6Average] = useState(0)

  const [filterReason, setFilterReason] = useState([])

  const host = 'https://nezcdev.dataa.com.tw'
  const ac = process.env.REACT_APP_SURVEY_AC
  const tk = process.env.REACT_APP_SURVEY_TK

  // const summary = "/back/health/v1/FetchProjectSummary";
  const raw = '/back/health/v1/FetchProjectRaw'
  // 2023
  // const pid1 = 'P230314142500'
  // const pid2 = 'P230523121246'
  // 2024
  // const pid1 = 'P240430105824'
  // const pid2 = 'P240430105853'
  // 2025
  const pid1 = 'P250423112413307'
  const pid2 = 'P250424001910598'

  useEffect(() => {
    setIsLoading(true)
    Promise.all([
      axios.post(
        host + raw,
        { pid: pid1 },
        {
          headers: {
            ac: ac,
            tk: tk,
          },
        }
      ),
      axios.post(
        host + raw,
        { pid: pid2 },
        {
          headers: {
            ac: ac,
            tk: tk,
          },
        }
      ),
    ])
      .then(([response1, response2]) => {
        setIsLoading(false)

        // console.log(response1.data.raw, response2.data.raw);
        const data1 = response1.data.raw
        const data2 = response2.data.raw
        // const newData = [...data1]
        const newData = [...data1, ...data2]
        // console.log('newData', newData)
        setData(newData)
        // 2023 過濾有效問卷
        // console.log(newData);
        // const removeDuplicateQi = (newData) => {
        //   return newData.map((item) => {
        //     let prevQi
        //     let seen9or10 = false
        //     let ansFiltered = []
        //     let qiCounter = 0

        //     for (let i = item.answers.length - 1; i >= 0; i--) {
        //       if (item.answers[i].qi === 9 || item.answers[i].qi === 10) {
        //         if (seen9or10) {
        //           continue // 如果已經看過qi:9或qi:10，就跳過這個
        //         } else {
        //           seen9or10 = true // 標記已經看過qi:9或qi:10
        //         }
        //       }

        //       if (item.answers[i].qi !== prevQi) {
        //         ansFiltered.unshift(item.answers[i])
        //         prevQi = item.answers[i].qi
        //         qiCounter++
        //         if (qiCounter >= 9) {
        //           break // 如果已經有九個不重複的qi，就跳出迴圈
        //         }
        //       }
        //     }

        //     return {
        //       ...item,
        //       answers: ansFiltered,
        //     }
        //   })
        // }

        // const processedData = removeDuplicateQi(newData)
        // setData(processedData)
        // console.log('processedData', processedData)
      })
      .catch((error) => {
        // 這裡處理任何一個請求失敗的情況
        console.error(error)
      })
  }, [])

  // Q1 潛在客戶總數
  function filterAnswersQ1(data) {
    return data.flatMap((item) =>
      item.answers.filter(
        (answer) =>
          answer.qi === 3 && JSON.stringify(answer.ans) === JSON.stringify([0])
      )
    )
  }

  // Q2 潛在客戶分布
  const conditions = [
    // 重複的: 明泰科技 達昇能源 佳世達
    { name: '其陽科技', qi1: 15, ans1: 0, qi2: 16, ans2: 0 },
    { name: '明泰科技', qi1: 15, ans1: 0, qi2: 16, ans2: 1 },
    { name: '達昇能源', qi1: 15, ans1: 0, qi2: 16, ans2: 2 },
    { name: '友通資訊', qi1: 15, ans1: 0, qi2: 16, ans2: 3 },

    { name: '明基電通 BenQ', qi1: 15, ans1: 1, qi2: 17, ans2: 0 },
    { name: '尚承科技', qi1: 15, ans1: 1, qi2: 17, ans2: 1 },

    { name: '拍檔科技', qi1: 15, ans1: 2, qi2: 18, ans2: 0 },
    { name: '典通', qi1: 15, ans1: 2, qi2: 18, ans2: 1 },
    { name: '星益欣', qi1: 15, ans1: 2, qi2: 18, ans2: 2 },

    { name: '德鴻科技', qi1: 15, ans1: 3, qi2: 19, ans2: 0 },
    { name: '八維智能', qi1: 15, ans1: 3, qi2: 19, ans2: 1 },
    { name: '邁達特', qi1: 15, ans1: 3, qi2: 19, ans2: 2 },
    { name: '逐鹿數位', qi1: 15, ans1: 3, qi2: 19, ans2: 3 },
    { name: '聚上雲', qi1: 15, ans1: 3, qi2: 19, ans2: 4 },

    { name: '達宣智慧', qi1: 15, ans1: 4, qi2: 20, ans2: 0 },
    { name: '浚鴻數據開發', qi1: 15, ans1: 4, qi2: 20, ans2: 1 },
    { name: '鈺緯科技', qi1: 15, ans1: 4, qi2: 20, ans2: 2 },
    { name: '佳世達', qi1: 15, ans1: 4, qi2: 20, ans2: 3 },

    // { name: '友通資訊', qi1: 15, ans1: 5, qi2: 21, ans2: 0 },
    { name: '仲琦科技', qi1: 15, ans1: 5, qi2: 21, ans2: 0 },
    { name: '明泰科技', qi1: 15, ans1: 5, qi2: 21, ans2: 1 },
    { name: '智通聯網', qi1: 15, ans1: 5, qi2: 21, ans2: 2 },

    { name: '眾福科技', qi1: 15, ans1: 6, qi2: 22, ans2: 0 },

    { name: '達昇能源', qi1: 15, ans1: 7, qi2: 23, ans2: 0 },
    { name: '維田科技', qi1: 15, ans1: 7, qi2: 23, ans2: 1 },
    { name: '羅昇企業', qi1: 15, ans1: 7, qi2: 23, ans2: 2 },

    { name: '佳世達', qi1: 15, ans1: 8, qi2: 24, ans2: 0 },

    // { name: '星益欣', qi1: 14, ans1: 0, qi2: 15, ans2: 0 },
    // { name: '拍檔科技', qi1: 14, ans1: 0, qi2: 15, ans2: 1 },
    // { name: '羅昇企業', qi1: 14, ans1: 1, qi2: 16, ans2: 0 },
    // { name: '達昇能源', qi1: 14, ans1: 1, qi2: 16, ans2: 1 },
    // { name: '維田科技', qi1: 14, ans1: 1, qi2: 16, ans2: 2 },
    // { name: '邁達特', qi1: 14, ans1: 2, qi2: 17, ans2: 0 },
    // { name: '逐鹿數位', qi1: 14, ans1: 2, qi2: 17, ans2: 1 },
    // { name: '聚上雲', qi1: 14, ans1: 2, qi2: 17, ans2: 2 },
    // { name: '仁大資訊 ', qi1: 14, ans1: 2, qi2: 17, ans2: 3 },
    // { name: '同星科技', qi1: 14, ans1: 2, qi2: 17, ans2: 4 },
    // { name: '八維智能', qi1: 14, ans1: 2, qi2: 17, ans2: 5 },
    // { name: '德鴻科技', qi1: 14, ans1: 2, qi2: 17, ans2: 6 },
    // { name: '典通', qi1: 14, ans1: 2, qi2: 17, ans2: 7 },
    // { name: '友通資訊', qi1: 14, ans1: 3, qi2: 18, ans2: 0 },
    // { name: '眾福科技', qi1: 14, ans1: 3, qi2: 18, ans2: 1 },
    // { name: 'BenQ', qi1: 14, ans1: 4, qi2: 19, ans2: 0 },
    // { name: '其陽科技', qi1: 14, ans1: 5, qi2: 20, ans2: 0 },
    // { name: '明泰科技', qi1: 14, ans1: 5, qi2: 20, ans2: 1 },
    // { name: '仲琦科技', qi1: 14, ans1: 5, qi2: 20, ans2: 2 },
  ]

  function countMatches(data, conditions) {
    // First count matches for each condition as before
    const allMatches = conditions.map((condition) => {
      let count = 0
      data.forEach((item) => {
        const hasQi1 = item.answers.some(
          (answer) =>
            answer.qi === condition.qi1 && answer.ans.includes(condition.ans1)
        )
        const hasQi2 = item.answers.some(
          (answer) =>
            answer.qi === condition.qi2 && answer.ans.includes(condition.ans2)
        )
        if (hasQi1 && hasQi2) {
          count++
        }
      })
      return { value: count, name: condition.name }
    })

    // Combine counts for companies with the same name
    const combinedMatches = []
    const processedNames = new Set()

    allMatches.forEach((match) => {
      if (!processedNames.has(match.name)) {
        processedNames.add(match.name)

        // Find all matches with the same name and sum their values
        const matchesWithSameName = allMatches.filter(
          (m) => m.name === match.name
        )
        const totalValue = matchesWithSameName.reduce(
          (sum, m) => sum + m.value,
          0
        )

        combinedMatches.push({ value: totalValue, name: match.name })
      }
    })

    return combinedMatches
  }

  // Q3 永續發展幫助程度 + Q4 永續場域觀念認同度
  const optionsQ3Q4 = {
    12: ['非常有幫助', '很有幫助', '有幫助', '沒有幫助', '非常沒有幫助'],
    13: ['非常認同', '很認同', '認同', '不認同', '非常不認同'],
  }

  function countAnswersForQ3Q4(data, qi, options) {
    const counts = options.map((description) => ({
      value: 0,
      name: description,
    }))

    data.forEach((item) => {
      item.answers.forEach((answer) => {
        if (answer.qi === qi) {
          answer.ans.forEach((ansValue) => {
            if (ansValue >= 0 && ansValue < options.length) {
              counts[ansValue].value += 1
            }
          })
        }
      })
    })

    return counts
  }

  const optionsQ5 = [
    '低碳展場設計(可循環利用建材)',
    'ESG專區(環保筆袋、資料袋、綠色產品)',
    '100%循環餐具',
    '展場推動無紙化、雲端整合',
    '展場推廣數位責任(智慧商場減少食物浪費、金融AI打詐等)',
  ]

  // Q5 深刻永續場域內容
  function countAnswersForQ5(data, descriptions) {
    const counts = descriptions.map((description) => ({
      value: 0,
      name: description,
    }))

    data.forEach((item) => {
      item.answers.forEach((answer) => {
        if (answer.qi === 14) {
          answer.ans.forEach((ansValue) => {
            if (ansValue >= 0 && ansValue < descriptions.length) {
              counts[ansValue].value += 1
            }
          })
        }
      })
    })

    return counts
  }

  useEffect(() => {
    if (data != null) {
      // console.log('data', data)
      // console.log('filterAnswersQ1(data)', filterAnswersQ1(data))
      // Q1 潛在客戶總數 定義:只留下首次填寫
      setTotalCount(filterAnswersQ1(data).length)
      console.log('filterAnswersQ1(data)', filterAnswersQ1(data))

      // ↓ 2023 的
      // let counts = options.map((optionArr) =>
      //   optionArr.map((option) => ({ value: 0, name: option }))
      // )

      // Q2 潛在客戶分布
      setQ2options(countMatches(data, conditions))

      // 2024 沒有用到這幾個
      // setQ3options(counts[1])
      // setQ4options(counts[2])
      // setOriginalQ4options(counts[2])

      // Q3 永續發展幫助程度
      setQ5options(countAnswersForQ3Q4(data, 12, optionsQ3Q4[12]))
      // Q4 永續場域觀念認同度
      setQ6options(countAnswersForQ3Q4(data, 13, optionsQ3Q4[13]))
      // Q5 深刻永續場域內容
      setQ7options(countAnswersForQ5(data, optionsQ5))

      // ↓ 2023 的
      // data.forEach((result) => {
      //   result.answers.forEach((answer) => {
      //     if (answer.qi >= 2 && answer.qi <= 7) {
      //       answer.ans.forEach((index) => {
      //         if (
      //           typeof index === 'number' &&
      //           index < counts[answer.qi - 2].length
      //         ) {
      //           counts[answer.qi - 2][index].value++
      //         }
      //       })
      //     }
      //   })
      // })

      // 初始化統計物件
      let optionCountMap = {}
      // 為每一題的每一個選項初始化一個空的計數物件
      let optionNames = [
        '智慧零售',
        '智慧製造',
        '智慧企業',
        '智慧交通',
        '智慧教育',
        '資安網通',
      ] // 第三題的選項
      let factorNames = [
        '人員服務好',
        '產品符合需求',
        '產品很吸睛',
        '介紹活潑完整',
        '展場互動體驗',
        '影片內容印象深刻',
      ] // 第四題的選項
      optionNames.forEach((name) => {
        optionCountMap[name] = factorNames.map((factor) => ({
          name: factor,
          value: 0,
        }))
      })
      data.forEach((result) => {
        let thirdQuestion = result.answers.find((answer) => answer.qi === 3)
        let fourthQuestion = result.answers.find((answer) => answer.qi === 4)

        // 檢查這個問卷是否有回答這兩題，並且第三題的答案只有一個
        if (thirdQuestion && fourthQuestion && thirdQuestion.ans.length === 1) {
          // 找到在第三題選擇的選項
          let chosenOptionName = optionNames[thirdQuestion.ans[0]]
          if (chosenOptionName) {
            // 為在第四題選擇的每一個選項增加計數
            fourthQuestion.ans.forEach((index) => {
              if (
                typeof index === 'number' &&
                index < optionCountMap[chosenOptionName].length
              ) {
                optionCountMap[chosenOptionName][index].value++
              }
            })
          }
        }
      })
      setFilterReason(optionCountMap)
    }
  }, [data])

  // Q5 Q6 平均
  useEffect(() => {
    if (q5options && q6options) {
      let q5Total = 0
      // 人數
      let q5Amount = 0
      q5options.forEach((element, i) => {
        q5Total += element.value * (5 - i)
        q5Amount += element.value
      })
      setQ5Average((q5Total / q5Amount).toFixed(2))

      let q6Total = 0
      let q6Amount = 0
      q6options.forEach((element, i) => {
        q6Total += element.value * (5 - i)
        q6Amount += element.value
      })
      setQ6Average((q6Total / q6Amount).toFixed(2))
    }
  }, [q5options, q6options])

  // Q4 Q7重排順序
  const [q4optionsSorted, setQ4optionsSorted] = useState([])
  const [q7optionsSorted, setQ7optionsSorted] = useState([])

  useEffect(() => {
    const order = [
      '產品符合需求',
      '人員服務好',
      '展場互動體驗',
      '介紹活潑完整',
      '產品很吸睛',
      '影片內容印象深刻',
    ]

    q4options.sort((a, b) => {
      return order.indexOf(a.name) - order.indexOf(b.name)
    })

    setQ4optionsSorted(q4options)
  }, [q4options])

  useEffect(() => {
    const order = [
      '智慧零售(智慧點餐)',
      '智慧企業(無紙化、上雲)',
      '智慧教育(翻轉偏鄉)',
      '能源管理(不斷電碳盤查)',
      '在地採購(綠色建材)',
      '循環杯',
    ]

    q7options.sort((a, b) => {
      return order.indexOf(a.name) - order.indexOf(b.name)
    })

    setQ7optionsSorted(q7options)
  }, [q7options])

  // ================================ companyAll ================================
  const [dataMax, setDataMax] = useState(
    Math.max(2000, Math.ceil(totalCount / 200) * 200)
  )

  useEffect(() => {
    setDataMax(Math.max(2000, Math.ceil(totalCount / 200) * 200))
  }, [totalCount])

  const companyAllChartOption = {
    title: {
      text: '潛在客戶總數(不重複)',
      left: 'center',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      formatter: '潛在客戶總數(不重複) {c} (人)',
    },
    dataset: {
      source: [[totalCount]],
    },
    grid: { containLabel: true },
    xAxis: { name: '(人)', min: 0, max: dataMax },
    yAxis: { type: 'category' },

    series: {
      label: {
        color: '#FFF',
        show: true,
        position: 'inside',
        textStyle: {
          fontSize: 16,
        },
      },
      color: '#DF0080',
      showBackground: true,
      type: 'bar',
      encode: {
        // Map the "amount" column to X axis.
        x: 'amount',
        // Map the "product" column to Y axis
        y: 'product',
      },
    },
  }

  // ================================ company ================================

  const companyChartOption = {
    title: {
      text: '潛在客戶分布',
      left: 'center',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      formatter: function (params) {
        const { name, value } = params.data
        return name + ' ' + value + ' (人)'
      },
    },
    dataset: [
      {
        dimensions: ['value', 'name'],
        source: q2options,
      },
      {
        transform: {
          type: 'sort',
          config: { dimension: 'value', order: 'asc' },
        },
      },
    ],
    grid: { containLabel: true },
    xAxis: {
      name: '(人)',
    },
    yAxis: {
      type: 'category',
      axisLabel: {
        textStyle: {
          fontSize: 16,
          color: '#595757',
        },
      },
    },
    series: {
      label: {
        color: '#FFF',
        show: true,
        position: 'inside',
      },
      color: '#FFC107',
      type: 'bar',
      encode: {
        x: 'value',
        y: 'name',
      },
      // data: q2options,
      datasetIndex: 1,
    },
  }

  // ================================ impressive ================================

  const impressiveChartOption = {
    title: {
      text: '最印象深刻的展區',
      left: 'left',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: '8%',
      left: 'left',
      textStyle: {
        fontSize: 16,
      },
    },
    label: {
      lineHeight: 15,
      formatter: function (params) {
        const { name, percent } = params
        return `${name} \n ${percent.toFixed(2)} %`
      },
      align: 'center',
    },
    series: [
      {
        color: [
          '#FFC107',
          '#E74C3C',
          '#2ECC71',
          '#3498DB',
          '#9B59B6',
          '#FF851B',
        ],
        type: 'pie',
        radius: '50%',
        data: q3options,
      },
    ],
  }

  // ================================ reason ================================

  const reasonChartOption = {
    title: {
      text: '印象深刻因素',
      // subtext: "Fake Data",
      left: 'left',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: '8%',
      left: 'left',
      textStyle: {
        fontSize: 16,
      },
    },
    label: {
      lineHeight: 15,
      formatter: function (params) {
        const { name, percent } = params
        return `${name} \n ${percent.toFixed(2)} %`
      },
      align: 'center',
    },
    series: [
      {
        color: [
          '#FFC107',
          '#E74C3C',
          '#2ECC71',
          '#3498DB',
          '#9B59B6',
          '#FF851B',
        ],
        // name: "Access From",
        type: 'pie',
        radius: '50%',
        data: q4optionsSorted,
      },
    ],
  }

  const [dropdownCurrentItem, setDropdownCurrentItem] = useState('全部展區')
  const [selectedChart, setSelectedChart] = useState('全部展區')

  useEffect(() => {
    switch (selectedChart) {
      case '全部展區':
        setQ4options(originalQ4options)
        setDropdownCurrentItem('全部展區')
        break
      case '智慧零售':
        setQ4options(filterReason['智慧零售'])
        setDropdownCurrentItem('智慧零售')
        break
      case '智慧製造':
        setQ4options(filterReason['智慧製造'])
        setDropdownCurrentItem('智慧製造')
        break
      case '智慧企業':
        setQ4options(filterReason['智慧企業'])
        setDropdownCurrentItem('智慧企業')
        break
      case '智慧交通':
        setQ4options(filterReason['智慧交通'])
        setDropdownCurrentItem('智慧交通')
        break
      case '智慧教育':
        setQ4options(filterReason['智慧教育'])
        setDropdownCurrentItem('智慧教育')
        break
      case '資安網通':
        setQ4options(filterReason['資安網通'])
        setDropdownCurrentItem('資安網通')
        break

      default:
        break
    }
  }, [selectedChart])

  // ================================ solution ================================

  const solutionChartOption = {
    title: {
      text: '永續發展幫助程度',
      left: 'left',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: '8%',
      left: 'left',
      textStyle: {
        fontSize: 16,
      },
    },
    label: {
      lineHeight: 15,
      formatter: function (params) {
        const { name, percent } = params
        return `${name} \n ${percent.toFixed(2)} %`
      },
      align: 'left',
    },
    series: [
      {
        color: [
          '#FFC107',
          '#E74C3C',
          '#2ECC71',
          '#3498DB',
          '#9B59B6',
          '#FF851B',
        ],
        // name: "Access From",
        type: 'pie',
        radius: '50%',
        // top: "15%",
        data: q5options,
      },
    ],
  }

  // ================================ sustainable ================================

  const sustainableChartOption = {
    title: {
      text: '永續場域觀念認同度',
      // subtext: "Fake Data",
      left: 'left',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: '8%',
      left: 'left',
      // orient: "vertical",
      textStyle: {
        fontSize: 16,
      },
    },
    label: {
      lineHeight: 15,
      formatter: function (params) {
        const { name, percent } = params
        return `${name} \n ${percent.toFixed(2)} %`
      },
      align: 'center',
    },
    series: [
      {
        color: [
          '#FFC107',
          '#E74C3C',
          '#2ECC71',
          '#3498DB',
          '#9B59B6',
          '#FF851B',
        ],
        // name: "Access From",
        type: 'pie',
        radius: '50%',
        // top: "20%",
        data: q6options,
      },
    ],
  }
  // ================================ sustainable ================================

  const impressiveSustainableChartOption = {
    title: {
      text: '深刻的永續場域內容',
      left: 'left',
      textStyle: {
        fontSize: 24,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: '8%',
      left: 'left',
      // align: "center",
      // orient: "vertical",
      textStyle: {
        fontSize: 16,
      },
    },
    label: {
      lineHeight: 15,
      formatter: function (params) {
        const { name, percent } = params
        return `${name} \n ${percent.toFixed(2)} %`
      },
      align: 'center',
    },
    series: [
      {
        color: [
          '#FFC107',
          '#E74C3C',
          '#2ECC71',
          '#3498DB',
          '#9B59B6',
          '#FF851B',
          '#E8A3E8',
        ],
        // name: "Access From",
        type: 'pie',
        radius: '50%',
        // center: ["60%", "40%"],
        top: '15%',
        // left: "30%",
        data: q7optionsSorted,
      },
    ],
  }

  return (
    <>
      <Container className="satisfyContainer mt-3">
        <Row className="company row justify-content-center">
          <Col xs={12}>
            <ReactEcharts
              style={{ width: '100%', height: '200px' }}
              option={companyAllChartOption}
            ></ReactEcharts>
          </Col>
          <Col xs={12}>
            <ReactEcharts
              style={{ width: '100%', height: '800px' }}
              option={companyChartOption}
            ></ReactEcharts>
          </Col>
        </Row>
        {/*<Row className="d-flex justify-content-center">
          <Col xs={12} md={5}>
            <ReactEcharts
              style={{ width: '100%', height: '500px' }}
              option={impressiveChartOption}
            ></ReactEcharts>
          </Col>
          <Col xs={12} md={5} className="position-relative">
            <ReactEcharts
              style={{ width: '100%', height: '500px' }}
              option={reasonChartOption}
            ></ReactEcharts>
            <Dropdown className="dropdownMargin">
              <Dropdown.Toggle
                variant="secondary"
                size="sm"
                id="dropdown-basic"
                className="btn me-1"
              >
                {dropdownCurrentItem}
              </Dropdown.Toggle>

              <Dropdown.Menu variant="secondary" size="sm" title="全部展區">
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('全部展區')
                  }}
                >
                  全部展區
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('智慧零售')
                  }}
                >
                  智慧零售
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('智慧製造')
                  }}
                >
                  智慧製造
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('智慧企業')
                  }}
                >
                  智慧企業
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('智慧交通')
                  }}
                >
                  智慧交通
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('智慧教育')
                  }}
                >
                  智慧教育
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedChart('資安網通')
                  }}
                >
                  資安網通
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row> */}
        <Row className="d-flex justify-content-center">
          <Col xs={12} md={5} className="mb-5">
            <ReactEcharts
              style={{ width: '100%', height: '550px' }}
              option={solutionChartOption}
            ></ReactEcharts>
            <div className="average text-secondary text-center">
              <h6>永續發展幫助程度平均: {q5Average} 分</h6>
            </div>
          </Col>
          <Col xs={12} md={5} className="mb-5">
            <ReactEcharts
              style={{ width: '100%', height: '550px' }}
              option={sustainableChartOption}
            ></ReactEcharts>
            <div className="average text-secondary text-center">
              <h6>永續場域觀念認同度平均: {q6Average} 分</h6>
            </div>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs={12} md={5}>
            <ReactEcharts
              style={{ width: '100%', height: '550px' }}
              option={impressiveSustainableChartOption}
            ></ReactEcharts>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Satisfy
